<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar  rounded dense elevation="1" color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="breadcrumbsItems" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar color="secondary" flat> 
                        <v-toolbar-title>
                            Modify Item Measure Unit 
                        </v-toolbar-title>
                        <v-spacer>

                        </v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete"/>                            
                            <PIconBtn icon="mdi-undo" tooltip="Cancel" @click="handleCancel"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
                    <v-divider></v-divider>
                        <v-col cols="12" md="12" class="text-center">
                            <ItemMeasureUnitForm 
                                ref="form" 
                                v-model="form"
                                v-if="!itemMeasureUnitLoading"
                                edit    
                            />
                        </v-col>
                        <div v-if="itemMeasureUnitLoading">
                           <v-col >
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader
                                    type="text"
                                >
                                </v-skeleton-loader>
                            </v-col>
                        </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PAlert from './../../components/common/PAlert.vue'
import PIconBtn from "./../../components/common/PIconBtn.vue"
import ItemMeasureUnitForm from "./../../components/warehouse/ItemMeasureUnitForm.vue"
export default {
    name: "ItemAccountEdit",
    components: {
        PIconBtn,
        ItemMeasureUnitForm,
        PAlert

    },
    data() {
        return {
            breadcrumbsItems: [
                { text: 'Warehouse & Inventory'},
                { text: 'Item' },
                { text: 'Modify Item Measure Unit' }
            ],
            form: null,
            itemMeasureUnitLoading: false,
            loading: false,
            measureUnitId: null,
            id: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            }
        }
    },
    methods: {
        ...mapActions({
            findByID: "stock/itemMeasureUnit/findByID",
            pushItem: "stock/item/search/push",
            snackbar: "ui/snackbar/show",
            update: "stock/itemMeasureUnit/update",
            pushMeasureUnit: "warehouse/measureUnit/search/push",
            remove: "stock/itemMeasureUnit/remove"

        }),
        fetchItemMeasureUnit() {   
            this.itemMeasureUnitLoading = true;
            this.findByID({itemId: this.id, measureUnitId: this.measureUnitId}).then(response => {
                this.pushMeasureUnit(response.data.measure_unit);
                this.pushItem(response.data.item);
                this.form = {};
                let data = {
                    item_id: response.data.item.id,
                    measure_unit_id: response.data.measure_unit.id,
                    conversion: response.data.conversion
                }
                this.form = data
            }).finally(() => {
                this.itemMeasureUnitLoading = false;   
            })
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to save?", callback: this.save};
            },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.form).then(() => {
                this.snackbar({ text: "Item Measure Unit Updated", color: "success"})
                this.$router.push({ name: "ItemDisplay", params: { id : this.id}})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Cancel?", callback: this.cancel};
        },
        cancel() {
            this.$router.push({ name: "ItemDisplay", params: { id : this.itemId} })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Delete?", callback: this.removeItemMeasureUnit};
        },
        removeItemMeasureUnit() {
            this.loading = true
            this.remove({itemId: this.id, measureUnitId: this.measureUnitId}).then(() => {
                this.snackbar({text: "Item Measure Unit Removed", color: "success"});
                this.$router.push({ name: "ItemDisplay", params: { id: this.id }});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    mounted() {
        if(this.$route.params.id && this.$route.params.unitId) {
            this.id = this.$route.params.id;
            this.measureUnitId = this.$route.params.unitId;
            this.fetchItemMeasureUnit();
        }
    }
}
</script>

<style>
</style>